<template>
  <v-dialog
    :value="visible"
    :max-width="896"
    id="textReviewPopup"
    @click:outside="closeClicked"
    @keydown.esc="closeClicked"
  >
    <v-card class="text-review-popup">
      <v-btn class="close-button" text @click="closeClicked" dense x-small>X</v-btn>
      <div class="inner-container">
        <v-card-title>
          <span class="title">{{ title }}</span>
        </v-card-title>
        <div class="scroller">
          <slot name="message">
            <v-card-text class="message"> {{ message }}</v-card-text>
          </slot>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'TextReviewPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      default: '',
    },
  },
  methods: {
    closeClicked() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
.v-dialog {
  overflow: hidden;
}

.close-button {
  .v-btn__content {
    font-size: 16px;
    color: #979797;
  }
}
</style>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.text-review-popup {
  display: flex;
  flex-direction: column;
  max-height: 90vh;

  .inner-container {
    padding: 42px 54px 38px 83px;

    .v-card__title {
      padding-left: 0px;
    }

    .scroller {
      overflow: auto;
      max-height: 50vh;

      box-sizing: border-box;
      border: 1px solid var(--border-primary);
      border-radius: $radius-sm;
      background-color: var(--bg-primary);
    }
  }

  .close-button {
    padding: $space-2-5;
    align-self: flex-end;
  }

  .title {
    color: var(--text-primary);
    font-size: $font-size-xl;
    letter-spacing: 0;
    line-height: $space-6;
  }

  .message {
    color: var(--text-primary);
    font-size: $font-size-base;
    letter-spacing: 0;
    line-height: $font-size-lg;
  }
}
</style>
